import charcoal from "../colors/charcoal"

const accordionStyle = {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${charcoal[200]}`,
      borderRadius: "8px !important",
      boxShadow: "none",
      "&:before": {
        height: 0
      },
      "& .MuiAccordionSummary-content, .MuiAccordionDetails-root": {
        display: "block"
      }
    }
  }
}
export default accordionStyle
